export default __webpack_public_path__ + "static/media/cog.1f5d2282.svg";